<template>
    <div>
        <div class="pinned-reports">
            <pinned-reports
                :pinned-reports-data="pinnedReportsData"
                :report-title="reportTitle"
                @unpinReports="unpinReports"
                @openReport="openReport"
            />
        </div>
        <ds-tabset id="reports-tab">
            <ds-tab label="Reports" selected>
                <all-reports
                    data-qa="keap-reports"
                    :report-title="reportTitle"
                    :is-centralized-reporting-hub-feature="isCentralizedReportingHubFeature"
                    @pinToTop="pinToTop"
                    @openReport="openReport"
                />
            </ds-tab>

            <ds-tab label="Saved searches">
                <all-saved-reports
                    data-qa="saved-reports"
                    :report-count="allSavedReports.totalResults"
                    :reports-object="allSavedReports.savedReportModels"
                    :is-created-by-enabled="allSavedReports.isCreatedByEnabled"
                    :is-pinned="true"
                    @pinToTop="pinToTop"
                    @isDeletePinnedReport="isDeletePinnedReport"
                    @openReport="openReport"
                />
            </ds-tab>
        </ds-tabset>
    </div>
</template>

<script>
import axios from 'axios';
import AllReports from './AllReports.vue';
import AllSavedReports from './AllSavedReports.vue';
import PinnedReports from './PinnedReports.vue';

export default {
    components: {
        AllReports,
        AllSavedReports,
        PinnedReports,
    },

    props: {
        reportsTitle: String,
    },

    data() {
        return {
            allSavedReports: {},
            pinnedReportsData: [],
            pinnedReportsList: [],
            reportTitle: this.reportsTitle,
            isCentralizedReportingHubFeature: false,
            isNewNav: false,
        };
    },

    created() {
        this.load();
    },

    methods: {
        async load() {
            this.getFeatureFlagValues();
            this.loadAllSavedReports();
            this.loadPinnedReports();
        },

        async loadAllSavedReports() {
            try {
                const response = await axios.get('/app/report/savedReports');

                this.allSavedReports = response.data;
            } catch (e) {
                this.$error({ message: 'Unable to get all saved reports' });
            }
        },

        async loadPinnedReports() {
            try {
                const response = await axios.get('/app/report/pinnedReports');

                this.pinnedReportsList = response.data;

                if (this.isCentralizedReportingHubFeature) {
                    this.pinnedReportsData = this.pinnedReportsList.filter((res) => res.reportCategoryType !== 'Sales' && res.reportCategoryType !== 'Visitors' && res.reportCategoryType !== 'Affiliate' && res.name !== 'Scheduled Actions' && res.name !== 'Follow-Up Sequence Dashboard Report' && res.name !== 'Email Dashboard Report');
                } else {
                    this.pinnedReportsData = this.pinnedReportsList;
                }
            } catch (e) {
                this.$error({ message: 'Unable to get pinned reports' });
            }
        },

        openReport(reportUrl) {
            if (this.isNewNav) {
                window.location.href = reportUrl;
            } else {
                window.open(reportUrl);
            }
        },

        async pinToTop(name) {
            if (this.pinnedReportsList.length < 10) {
                const req = {
                    reportName: name,
                };

                try {
                    const res = await axios.post('/app/report/pinReport', req);

                    if (res.status === 208) {
                        this.$toast({ message: 'Report is already pinned' });
                    } else {
                        this.$toast({ message: 'Report is pinned successfully' });
                        this.loadPinnedReports();
                    }
                } catch (error) {
                    this.$toast({ message: 'Unable to pin this report' });
                }
            } else {
                this.$toast({ message: 'Pinned reports limit is reached' });
            }
        },

        async unpinReports(name) {
            const req = {
                reportName: name,
            };

            try {
                await axios.put('/app/report/unPinReport', req);

                this.$toast({ message: 'Report is unpinned successfully' });
                this.loadPinnedReports();
            } catch (error) {
                this.$toast({ message: 'Unable to unpin this report' });
            }
        },

        isDeletePinnedReport() {
            this.load();
        },

        async getFeatureFlagValues() {
            try {
                const centralizedReporting = await axios.get('/app/report/isCentralizedReportingHubFeature');

                this.isCentralizedReportingHubFeature = centralizedReporting.data;
            } catch (e) {
                this.$error({ message: 'Unable get featureFlag value' });
            }

            try {
                const newNav = await axios.get('/app/nav/isNewNav');

                this.isNewNav = newNav.data;
            } catch (e) {
                this.$error({ message: 'Unable get user module setting' });
            }
        },
    },
};
</script>

<style lang="scss">
    #reports-tab > .tab-content {
        position:relative;
        left: 0;
        top: 0;
        clear: both;
        visibility: visible;
    }

    .pinned-reports {
        padding-bottom: $spacing-200;
    }

    .table-wrapper tr.selectable-row:last-child .dropdown-menu.open {
        inset: auto 0 0 auto !important;
        transform: translate(0, 0%) !important;
    }
</style>
